<template>
  <div class="flex-container">
    <section class="img-container flex-1">
      <div class="img-inline" v-for="(src, index) in imgList" :key="index">
        <div class="mask"></div>
        <van-image class="merchandise-info__image" width="60px" height="60px" :src="src"></van-image>
      </div>
    </section>
    <div v-if="isShowGoodList" class="detail-container" @click.stop="processShowGoodsDetail">
      <span>共{{ goodsNum }}件</span>
      <van-icon name="cap-arrow" color="#bfbfbf" />
    </div>
    <div v-else class="detail-container">
      <span>共{{ goodsNum }}件</span>
      <van-icon name="cap-arrow" color="#bfbfbf" />
    </div>

    <van-modal-sheet
      v-model="showModal"
      title="商品明细"
      right-text="关闭"
      right-text-color="#8C8C8C"
      @titleRightClick="showModal = false"
    >
      <div style="padding: 0 12px">
        <goods-item v-for="(item) in goodsList" :key="item.itemId" :goods="item"></goods-item>
      </div>
    </van-modal-sheet>
  </div>
</template>
<script>
import goodsItem from '@/components/goodsItem.vue';
export default {
  components: {
    goodsItem
  },
  props: {
    goodsList: {
      type: Array,
      default: () => []
    },
    itemCount: {
      type: Number,
      default: 0
    },
    isShowGoodList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    imgList() {
      let arr = [...this.goodsList];
      return arr.slice(0, 6).map((item) => item.mainImg);
    },
    goodsNum() {
      if (this.itemCount) return this.itemCount;
      return this.goodsList.reduce((acc, cur) => acc + cur.itemNum, 0);
    }
  },
  methods: {
    processShowGoodsDetail() {
      this.showModal = true;
    }
  }
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  .flex-1 {
    flex: 1;
  }
  .img-container {
    display: inline-flex;
    flex-wrap: nowrap;
    overflow: hidden;
    .img-inline {
      position: relative;
      .mask {
        width: 60px;
        height: 60px;
        background: rgba(0, 0, 0, 0.02);
        z-index: 2;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 4px;
      }
    }
    .merchandise-info__image {
      min-width: 60px;
      margin-right: 6px;
      border-radius: 4px;
    }
  }
  .detail-container {
    color: #8c8c8c;
    font-size: 12px;
    padding-left: 12px;
    height: 60px;
    display: inline-flex;
    align-items: center;
  }
}
</style>